import { useState, useEffect, Suspense, lazy, useMemo } from "react";
import Navbar from "./Navbar";
import DashboardCard from "./DashboardCard";
import FullScreenLoader from "./FullScreenLoader";
import BackButton from "./BackButton";
import { url, getModules } from "../config";

import { getAppVersion } from './../modules/Mobile/helper/Appversion';
// import { moduleComponents } from "./Modulespath";

//mobile app
// import { useNavigate } from "react-router-dom";


export default function Dashboard({ onLogout }) {

  const [selectedParent, setSelectedParent] = useState(null);
  const [selectedModule, setSelectedModule] = useState(null);
  const [selectedChild, setSelectedChild] = useState(null);
  const [modules, setModules] = useState({});
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isTablet, setIsTablet] = useState(window.innerWidth <= 1024);
  const [dashBoardLoading, setDashBoardLoading] = useState(true);
  const canShowModule = (module) => {
    // If platform is not defined, don't show the module
    if (!module.platform) {
      return false;
    }

    switch (module.platform) {
      case "mobile":
        return isMobile;

      case "desktop":
        return !isMobile;

      case "both":
        return true;

      default:
        return false;
    }
  };

  const getParentModuleCounts = (parentTitle) => {
    switch (parentTitle) {
      case "Direct Lamp Installation":
        return SummaryCounts.DirectLampInstallation;

      default:
        return null;
    }
  };

  // useEffect(() => {
  //   if (selectedParent === null) {
  //     alert(1)
  //     getsummarycounts("Direct Lamp Installation");
  //   }
  // }, [selectedParent]);


  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      setIsTablet(window.innerWidth <= 1024);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // useEffect(() => {
  //   const storedModules = JSON.parse(localStorage.getItem("modules")) || {};
  //   setModules(storedModules);
  // }, []);

  useEffect(() => {
    setModules(getModules());
  }, []);


  useEffect(() => {
    if (!selectedModule && selectedParent) {
      const parentTitle = modules[selectedParent]?.title;

      if (
        parentTitle === "Indexing" ||
        parentTitle === "Installation" ||
        parentTitle === "Direct Lamp Installation" ||
        parentTitle === "Indexing QC" ||
        parentTitle === "Installation QC" ||
        parentTitle === "Direct Lamp Installation QC"
      ) {
        getsummarycounts(parentTitle);
      }
    }
    if (selectedParent === null && isMobile) {
      getsummarycounts("Direct Lamp Installation");
    }
  }, [selectedModule, selectedParent, modules]);
  // SelectedModule comes from modules config.
  // Mobile pages expect AuthContext provider (useAuth) to exist.
  // const SelectedComponent = moduleComponents[selectedModule];


  const SelectedComponent = useMemo(() => {
    if (!selectedModule) return null;

    return lazy(() => import(`../modules/${selectedModule.path}`));
  }, [selectedModule]);


  const [SummaryCounts, setSummaryCounts] = useState({
    // INDEXING
    poleIndexing: {
      completedCount: 0,
    },

    switchIndexing: {
      completedCount: 0,
    },

    // INSTALLATION
    lampInstallation: {
      countAllotted: 0,
      countPending: 0,
    },

    DirectLampInstallation: {
      completedCount: 0,
    },

    //indexingQC
    poleIndexingQC: {
      pendingCount: 0,
      approvedCount: 0,
      totalCount: 0,
    },

    switchIndexingQC: {
      pendingCount: 0,
      approvedCount: 0,
      totalCount: 0,
    },

    //Installation QC
    lampInstallationQC: {
      pendingCount: 0,
      approvedCount: 0,
      totalCount: 0,
    },

    DirectLampInstallationQC: {
      pendingCount: 0,
      approvedCount: 0,
      totalCount: 0,
    }
  });

  const getsummarycounts = async (title) => {
    const appVersion = await getAppVersion();
    let formData = {};

    try {

      // INDEXINGQC
      if (title === "Indexing QC") {

        formData = {
          moduleName: "IndexingQC",
          workforce: "GetIndexingQCSummaryCounts",
          dashboardcounts: "true",
          appVersion: appVersion
        };

      }

      // INSTALLATIONQC
      else if (title === "Installation QC") {
        formData = {
          moduleName: "InstallationQC",
          workforce: "GetInstallationQCSummary",
          dashboardcounts: "true",
          appVersion:appVersion
        };
      }

      else if (title === "Direct Lamp Installation QC") {
        formData = {
          moduleName: "InstallationQC",
          workforce: "GetInstallationQCSummary",
          dashboardcounts: "true",
          appVersion: appVersion
        };
      }


      else if (title === "Indexing") {
        formData = {
          moduleName: "Indexing",
          workforce: "GetIndexingSummaryCounts",
          dashboardcounts: "true",
          appVersion:appVersion
        };
      }

      else if (title === "Installation") {
        formData = {
          moduleName: "Installation",
          workforce: "GetInstallationSummaryCounts",
          dashboardcounts: "true",
          appVersion:appVersion
        }
      }

      else if (title === "Direct Lamp Installation") {
        formData = {
          moduleName: "DirectLampInstallation",
          workforce: "getDirectLampInstallationCounts",
          dashboardcounts: "true",
          appVersion:appVersion
        };
      }


      const res = await fetch(url, {
        method: "POST",

        headers: {
          "Content-Type":
            "application/x-www-form-urlencoded",

          Authorization:
            "Bearer " +
            localStorage.getItem("authKey"),
        },

        body: new URLSearchParams(formData),
      });

      if (!res.ok) {
        throw new Error("Network response failed");
      }

      const result = await res.json();

      if (result.Result === 1) {

        // INDEXING COUNTS
        if (title === "Indexing QC") {

          setSummaryCounts((prev) => ({
            ...prev,

            poleIndexingQC: {
              pendingCount:
                result?.data?.poleIndexing
                  ?.pendingCount || 0,

              approvedCount:
                result?.data?.poleIndexing
                  ?.approvedCount || 0,

              totalCount:
                result?.data?.poleIndexing
                  ?.totalCount || 0,
            },

            switchIndexingQC: {
              pendingCount:
                result?.data?.switchIndexing
                  ?.pendingCount || 0,

              approvedCount:
                result?.data?.switchIndexing
                  ?.approvedCount || 0,

              totalCount:
                result?.data?.switchIndexing
                  ?.totalCount || 0,
            },
          }));
        }

        // INSTALLATION COUNTS
        else if (title === "Installation QC") {
          setSummaryCounts((prev) => ({
            ...prev,
            lampInstallationQC: {
              pendingCount:
                result?.data?.lampInstallation?.pendingCount ?? 0,
              approvedCount:
                result?.data?.lampInstallation?.approvedCount ?? 0,
              totalCount:
                result?.data?.lampInstallation?.totalCount ?? 0,
            },

            DirectLampInstallationQC: {
              pendingCount:
                result?.data?.DirectLampInstallationQC?.pendingCount ?? 0,
              approvedCount:
                result?.data?.DirectLampInstallationQC?.approvedCount ?? 0,
              totalCount:
                result?.data?.DirectLampInstallationQC?.totalCount ?? 0,
            },
          }));
        }

        else if (title === "Indexing") {
          setSummaryCounts((prev) => ({
            ...prev,

            poleIndexing: {
              completedCount:
                result?.data?.poleIndexing?.completedCount ?? 0,
            },

            switchIndexing: {
              completedCount:
                result?.data?.switchIndexing?.completedCount ?? 0,
            },
          }));
        }

        // INSTALLATION
        else if (title === "Installation") {
          setSummaryCounts((prev) => ({
            ...prev,

            lampInstallation: {
              countAllotted:
                result?.data?.lampInstallation?.countAllotted ?? 0,

              countPending:
                result?.data?.lampInstallation?.countPending ?? 0,
            },
          }));
        }

        else if (title === "Direct Lamp Installation") {
          setSummaryCounts((prev) => ({
            ...prev,
            DirectLampInstallation: {
              completedCount:
                result?.data?.DirectLampInstallation?.completedCount ??
                result?.data?.completedCount ??
                0,
                 userCompletedCount:
                result?.data?.DirectLampInstallation?.userCompletedCount ??
                result?.data?.userCompletedCount ??
                0,
            },
          }));
        }

      } else if (result.Result === -4) {
        window.M.toast({ html: "Session expired, login again" });
        onLogout();
      }
      setDashBoardLoading(false)
    } catch (error) {

      console.error(
        "Summary count fetch failed:",
        error
      );

      // INDEXING FALLBACK
      if (title === "Indexing QC") {

        setSummaryCounts((prev) => ({
          ...prev,

          poleIndexingQC: {
            pendingCount: 0,
            approvedCount: 0,
            totalCount: 0,
          },

          switchIndexingQC: {
            pendingCount: 0,
            approvedCount: 0,
            totalCount: 0,
          },
        }));
      }

      // INSTALLATION FALLBACK
      else if (title === "Installation QC") {

        setSummaryCounts((prev) => ({
          ...prev,

          lampInstallationQC: {
            pendingCount: 0,
            approvedCount: 0,
            totalCount: 0,
          },
          DirectLampInstallationQC: {
            pendingCount: 0,
            approvedCount: 0,
            totalCount: 0,
          },
        }));
      }
    }
  };

  const getModuleCounts = (moduleTitle) => {
    const title = moduleTitle.toLowerCase();
    const parentTitle = selectedParent ? modules[selectedParent]?.title : "";

    if (parentTitle === "Direct Lamp Installation") {
      return SummaryCounts.DirectLampInstallation;
    }

    if (parentTitle === "Direct Lamp Installation QC") {
      return SummaryCounts.DirectLampInstallationQC;
    }
    if (title.includes("pole")) {
      return parentTitle === "Indexing QC"
        ? SummaryCounts.poleIndexingQC
        : SummaryCounts.poleIndexing;
    }

    if (title.includes("switch")) {
      return parentTitle === "Indexing QC"
        ? SummaryCounts.switchIndexingQC
        : SummaryCounts.switchIndexing;
    }

    if (title.includes("direct")) {
      return parentTitle === "Installation QC"
        ? SummaryCounts.DirectLampInstallationQC
        : SummaryCounts.DirectLampInstallation;
    }

    if (title.includes("lamp")) {
      return parentTitle === "Installation QC"
        ? SummaryCounts.lampInstallationQC
        : SummaryCounts.lampInstallation;
    }

    return null;
  };
  const getGridColumns = () => {
    if (isMobile) {
      return "1fr";
    } else if (isTablet) {
      return "repeat(2, 1fr)";
    } else {
      return "repeat(auto-fill, minmax(380px, 1fr))";
    }
  };

  const getPadding = () => {
    if (isMobile) {
      return "15px 12px";
    } else if (isTablet) {
      return "20px";
    } else {
      return "30px";
    }
  };

  return (
    <>
      <Navbar isLoggedIn={true} onLogout={onLogout} />

      {SelectedComponent && (
        <Suspense fallback={<FullScreenLoader />}>
          <SelectedComponent
            // keep load as stored module id; mobile pages call APIs using this prop
            load={selectedModule.module}
            onBack={() => setSelectedModule(null)}
            onLogout={onLogout}
          />
        </Suspense>
      )}


      {/* SUB CHILD VIEW */}
      {!selectedModule && selectedParent && !selectedChild && (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: isMobile ? "10px 8px 8px 8px" : "0px 10px 10px 10px",
            }}
          >
            <BackButton
              onBack={() => setSelectedParent(null)}
              title={modules[selectedParent].title}
            />
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: getGridColumns(),
              gap: isMobile ? "12px" : "20px",
              padding: getPadding(),
            }}
          >
            {canShowModule(modules[selectedParent]) &&
              Object.entries(modules[selectedParent]?.children || {}).map(([key, module]) => (

                <DashboardCard
                  key={key}
                  title={module.title}
                  icon={module.icon}
                  gradient={module.gradient}
                  counts={getModuleCounts(module.title)}
                  dashBoardLoading={dashBoardLoading}
                  onClick={() => {
                    // if (module.platform === "mobile") {
                    //   handleCardClick(module);
                    //   return;
                    // }

                    if (module.subchildren) {

                      setSelectedChild(key);

                    } else {

                      setSelectedModule(module);
                    }

                  }}
                />
              ))}
          </div>
        </>
      )}

      {/* CHILD VIEW */}
      {!selectedModule && selectedChild && (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: isMobile ? "10px 8px 8px 8px" : "0px 10px 10px 10px",
            }}
          >
            <BackButton
              onBack={() => setSelectedChild(null)}
              title={modules[selectedParent]?.children[selectedChild]?.title}
            />
          </div>


          <div
            style={{
              display: "grid",
              gridTemplateColumns: getGridColumns(),
              gap: isMobile ? "12px" : "20px",
              padding: getPadding(),
            }}
          >
            {canShowModule(modules[selectedParent]) &&
              Object.entries(
                modules[selectedParent]?.children[selectedChild]?.subchildren || {}
              ).map(([key, sub]) => (
                <DashboardCard
                  key={key}
                  title={sub.title}
                  icon={sub.icon}
                  gradient={sub.gradient}
                  onClick={() => setSelectedModule(sub)}
                />
              ))}
          </div>
        </>
      )}

      {/* PARENT VIEW */}
      {!selectedModule && !selectedParent && (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: getGridColumns(),
            gap: isMobile ? "12px" : "20px",
            padding: getPadding(),
          }}
        >
          {Object.entries(modules)
            .filter(([_, parent]) => canShowModule(parent))
            .map(([key, parent]) => (
              <DashboardCard
                key={key}
                title={parent.title}
                icon={parent.icon}
                gradient={parent.gradient}
                counts={getParentModuleCounts(parent.title)}
                dashBoardLoading={dashBoardLoading}
                onClick={() => {
                  if (parent.module) {
                    setSelectedModule(parent);
                  } else {
                    setSelectedParent(key);
                  }
                  // if (
                  //   parent.title === "Indexing" ||
                  //   parent.title === "Installation" ||
                  //   parent.title === "Indexing QC" ||
                  //   parent.title === "Installation QC"
                  // ) {
                  //   getsummarycounts(parent.title);
                  // }
                }}
              />
            ))}
        </div>
      )}
    </>
  );
}
